import { render, staticRenderFns } from "./OnboardingInvite.vue?vue&type=template&id=8c678616&"
import script from "./OnboardingInvite.vue?vue&type=script&lang=js&"
export * from "./OnboardingInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports